import CustomerBaseController from '../common/customer.base.controller'

class CustomerallController extends CustomerBaseController {
  /*@ngInject*/
  constructor(Auth, $state, User, Modal, CustomerService, $translate, $stateParams, $scope, $location, Navigation) {

    super(Auth, $state, User, CustomerService, Modal, $translate, $stateParams, $location)

    this.id = 'customer.all'
    this.loading = true
    this.customers = []
    this.page = 1
    this.total = 0
    this.pageLimit = 10
    this.maxPages = 10
    this.hasACL = {}
    this._status = 'active'
    this.customerTypeList = ['all', 'types', 'active', 'inactive'];
    this.Navigation = Navigation;
    this.userStatus = this.customerTypeList.map((list) => {
      return {
        value: list,
        label: $translate.instant('customer_types.' + list)
      };
    });
    this.searchText = '';
    this.$location = $location;
    this.branchId = this.User.getUser().branchId;
    this.customerHistoryStats = {
      locations: 'locations',
      contracts: 'contracts'
    }
    this.currentStats = {};

    this.weekDays = {
      'serviceScheduleSun': 'Sun',
      'serviceScheduleMon': 'Mon',
      'serviceScheduleTue': 'Tue',
      'serviceScheduleWed': 'Wed',
      'serviceScheduleThu': 'Thu',
      'serviceScheduleFri': 'Fri',
      'serviceScheduleSat': 'Sat',
      'serviceScheduleHol': 'Hol'
    };

    this.customerLocationHistoryObj = {
      totalRecords: 0,
      results: [],
      loading: false,
      pagination: {
        page: 1,
        total: 0,
        pageLimit: 10,
        maxPages: 10
      },
      allowOnlyOnce: false,
      errorMessage: '',
      searchText: '',
      history: {},
      extraDetails: {},
      // sortColumn: 'locationId',
      // reverseSort: true
    };

    this.customerContractHistoryObj = {
      totalRecords: 0,
      results: [],
      loading: false,
      pagination: {
        page: 1,
        total: 0,
        pageLimit: 10,
        maxPages: 10
      },
      allowOnlyOnce: false,
      errorMessage: '',
      searchText: '',
      history: {},
      extraDetails: {},
      // sortColumn: 'locationId',
      // reverseSort: true
    }

    this.sortColumn = '';
    this.reverseSort = true;

    this.locationTypeIcon = {
      'REGULAR': 'regular.png',
      'ATM': 'atm.png',
      'BANK': 'bank.png',
      'NO_SHIP_NO_GO': 'nsng.png',
      'INTERNAL': 'internal.png',
      'TRUCK': 'truck.png',
      'TANKER': 'tanker.png',
      'WINDOW': 'window.png',
      'ON_CALL': 'oncall.png',
      'CARRIER': 'carrier.png',
      'LOCKER': 'locker.png',
      'VAULT': 'vault.png',
      'DELIVERY': 'delivery.png'
    }
  }

  $onInit() {
    let pageId = this.$stateParams.page
    if (pageId > 0) {
      this.page = pageId
    }
    this.loadData()
  }

  edit(customer) {
    this.$state.go('customer.edit', ({
      id: customer.id
    }))
  }

  delete(customer) {
    if (this.allowOnlyOnce) return;
    this.allowOnlyOnce = true;
    this.Modal.confirm({
      header: this.$translate.instant('common.confirm_delete_title'),
      message: this.$translate.instant('common.confirm_delete_message') + ` <strong>${customer.id}</strong>?`,
      callback: (({
        modal,
        $scope
      }) => {
        $scope.loading = true
        this.Service.remove(customer.id, this.branchId)
          .then((data) => {
            this.allowOnlyOnce = false;
            modal.close()
            this.refresh()
          })
      }),
      negative: (({
        modal,
      }) => {
        this.allowOnlyOnce = false;
        modal.close();
      }),
      type: 'danger'
    })
  }

  refresh() {
    this.loadData()
  }

  pageChange() {
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData()
  }

  search() {
    this.page = 1;
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData()
  }

  generateSearchObj() {
    const searchObj = {
      queryJSON: {
        rules: [
          {
            group: {
              rules: [
                {
                  field: 'id',
                  condition: 'like',
                  data: `%${this.searchText}%`
                },
                {
                  field: 'name',
                  condition: 'like',
                  data: `%${this.searchText}%`
                },
              ],
              operator: 'OR'
            }
          }
        ],
        operator: 'AND'
      }
    };
    switch (this._status) {
      case 'active': {
        searchObj.queryJSON.rules.push({
          field: 'isEnabled',
          condition: '=',
          data: true
        });
        break;
      }
      case 'inactive': {
        searchObj.queryJSON.rules.push({
          field: 'isEnabled',
          condition: '=',
          data: false
        });
        break;
      }
    }
    return searchObj;
  }

  loadData(searchText) {
    const searchObj = this.generateSearchObj();

    this.loading = true
    this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit)
      .then((data) => {
        this.total = data.total

        this.loading = false
        this.customers = data.results
      })
      .catch((err) => {
        this.loading = false
        this.error = err.message
      })
  }

  toggleExpand(customer) {
    customer.expand = !customer.expand;
    this.currentStats[customer.id] = this.customerHistoryStats.locations;
  }

  getCurrentStats(obj, value) {
    if (!obj.expanded) return;
    this.currentStats[obj.id] = value;
  }

  // ------------------------------------------ Customer location history logic section start ------------------------------------------ //

  setLocationHistoryPage(isExpanded, customerId) {
    if (!isExpanded) return;
    this.customerLocationHistoryObj.extraDetails[customerId] = { page: 1 };
  }

  getCustomerLocationHistory(data, event) {
    const customerId = data.id;
    let serviceDays = [];

    document.getElementById(`expand-btn-${customerId}`).blur();
    if (!data.expanded) return;

    this.customerLocationHistoryObj.history[customerId] = { process: true };

    this.Service.getCustomerLocationHistory(this.customerLocationHistoryObj.extraDetails[customerId].searchText, customerId, this.reverseSort, this.sortColumn,
      (this.customerLocationHistoryObj.extraDetails[customerId].page - 1) * this.customerLocationHistoryObj.pagination.pageLimit,
      this.customerLocationHistoryObj.pagination.pageLimit)
      .then((history) => {
        this.customerLocationHistoryObj.history[customerId].details = history;
        this.customerLocationHistoryObj.history[customerId].details.pageLimit = this.customerLocationHistoryObj.pagination.pageLimit;

        this.customerLocationHistoryObj.history[customerId].details.results.forEach((history) => {
          Object.keys(this.weekDays).forEach(key => {
            if (history[key]) serviceDays.push(this.weekDays[key])
          })
          history.serviceDays = serviceDays;
          serviceDays = [];
        })
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.customerLocationHistoryObj.history[customerId].process = false;
      })
  }

  sortData(column, obj, event) {
    this.reverseSort = (this.sortColumn == column) ? !this.reverseSort : false;
    this.sortColumn = column;
    this.loadCustomerHistory(obj, event);
  }

  goToServiceHistory(locationId) {
    this.Navigation.goToServiceHistory(locationId, null, true, null);
  }

  loadLocationTypeImage = function (image) {
    let imgURL = this.locationTypeIcon[image]
    return require('../../../../../assets/images/' + imgURL);
  }

  searchLocationHistory(data, event) {
    this.customerLocationHistoryObj.extraDetails[data.id].page = 1;
    this.getCustomerLocationHistory(data, event);
  }

  // ------------------------------------------ Customer location history logic section end ------------------------------------------ //

  resetSearchText(obj) {
    const customerId = obj.id;
    
    this.customerLocationHistoryObj.extraDetails[customerId] = { searchText: '' };
    this.customerContractHistoryObj.extraDetails[customerId] = { searchText: '' };

    this.customerLocationHistoryObj.extraDetails[customerId].searchText = '';
    this.customerContractHistoryObj.extraDetails[customerId].searchText = '';
  }

  loadCustomerHistory(obj, event) {
    if (this.currentStats[obj.id] === this.customerHistoryStats.locations) this.getCustomerLocationHistory(obj, event);
    else if (this.currentStats[obj.id] === this.customerHistoryStats.contracts) this.getCustomerContractHistory(obj, event);
  }

  locationHistoryFn(obj, event) {
    this.resetSearchText(obj);
    this.getCurrentStats(obj, this.customerHistoryStats.locations);
    this.setLocationHistoryPage(obj.expanded, obj.id);
    this.loadCustomerHistory(obj, event)
  }

  // ------------------------------------------ Customer contract history logic section start ------------------------------------------ //

  setContractHistoryPage(isExpanded, customerId) {
    if (!isExpanded) return;
    this.customerContractHistoryObj.extraDetails[customerId] = { page: 1 };
  }

  getCustomerContractHistory(data, event) {
    const customerId = data.id;

    document.getElementById(`expand-btn-${customerId}`).blur();
    if (!data.expanded) return;

    this.customerContractHistoryObj.history[customerId] = { process: true };

    this.Service.getCustomerContractHistory(this.customerContractHistoryObj.extraDetails[customerId].searchText, customerId, this.reverseSort, this.sortColumn,
      (this.customerContractHistoryObj.extraDetails[customerId].page - 1) * this.customerContractHistoryObj.pagination.pageLimit,
      this.customerContractHistoryObj.pagination.pageLimit)
      .then((history) => {
        this.customerContractHistoryObj.history[customerId].details = history;
        this.customerContractHistoryObj.history[customerId].details.pageLimit = this.customerContractHistoryObj.pagination.pageLimit;
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.customerContractHistoryObj.history[customerId].process = false;
      })
  }

  searchContractHistory(data, event) {
    this.customerContractHistoryObj.extraDetails[data.id].page = 1;
    this.getCustomerContractHistory(data, event);
  }

  goToContractHistory(contractId) {
    this.$state.go('contract.edit', ({
      id: contractId
    }))
  }

  contractHistoryFn(obj, event) {
    this.resetSearchText(obj);
    this.getCurrentStats(obj, 'contracts');
    this.setContractHistoryPage(obj.expanded, obj.id);
    this.loadCustomerHistory(obj, event)
  }

  // ------------------------------------------ Customer contract history logic section end ------------------------------------------ //

  exportCustomerLocationHistory(customer) {
    let customerId = customer.id;

    this.customerLocationHistoryObj.extraDetails[customerId].isExport = true;
    const reportPrefix = `Customer_Location(${customer.name})`;
    
    this.Service.exportCustomerLocationHistory(customerId, this.customerLocationHistoryObj.extraDetails[customerId].searchText, this.reverseSort, this.sortColumn)
      .then((data) => {
        this.downloadFile(customerId, reportPrefix, data.reportData)
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.customerLocationHistoryObj.extraDetails[customerId].isExport = false;
      })
  }

  downloadFile(customerId, reportPrefix, reportData) {
    const fileName = reportPrefix.concat('.csv');
    const a = document.createElement("a");
    document.body.appendChild(a);
    const file = new Blob([reportData], { type: 'application/csv' });
    const fileURL = window.URL.createObjectURL(file);
    a.href = fileURL;
    a.download = fileName;
    a.click();
  }

  exportCustomerLocationBillingRule(customer) {
    let customerId = customer.id;
    let contractId = customer.billToContractTransportId;

    this.customerLocationHistoryObj.extraDetails[customerId].isExportCustomerBillingRule = true;
    const reportPrefix = `Customer_Location_Billing_Rules_Detail(${customer.name})`;

    this.Service.exportCustomerLocationBillingRule(customerId, contractId)
      .then((data) => {
        if (customer.totalContracts === 0) {
          this.Modal.errorModal(`No Contract Rules Are Associated With Contract <b>${contractId}</b>`)
          return
        }
        else if (_.isEmpty(data)) {
          this.Modal.errorModal(`Contract <b>${contractId}</b> Is Having Contract Rules Are Not Associated With Any Location.`)
          return
        }
        else this.downloadFile(customerId, reportPrefix, data.reportData)
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.customerLocationHistoryObj.extraDetails[customerId].isExportCustomerBillingRule = false;
      })
  }
}

export default CustomerallController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/customer/all/customer.all.controller.js